import { createSelector } from '@ngrx/store';

import { safeSelect, StateSelector } from '@fcom/core/selectors/selector-utils';

import { CommonBookingFeatureState, CommonBookingState } from '../store.interface';
import { selectCommonBookingState } from './feature.selector';

const _selectedBoundIdState = createSelector(
  selectCommonBookingState,
  (state: CommonBookingState) => state?.disruption?.selectedBoundId
);

export const selectedBoundId = (): StateSelector<CommonBookingFeatureState, string> =>
  safeSelect(_selectedBoundIdState);
